import {SubjectModelV2} from 'resources/GeneratedModels/Subject/SubjectModel.v2';

import {subjectExtensions} from './subject.extensions';

SubjectModelV2.extend(subjectExtensions);

export {SubjectModelV2};
